<script>
 export default {
    name: "application-header",
    props: {
        projectLogo: String,
        projectName: String
    },
    computed: {
        imageSrc() {
            if (this.projectLogo) {
                return '/storage/mediapool/project_logo/' + this.projectLogo;
            }

            return '/img/logo-easescreen-white.svg';
        },
        imageClass() {
            if (this.projectLogo) {
                return 'navbar-brand custom';
            }

            return 'navbar-brand';
        }
    },
     methods: {
         handleClickNavigation() {
             const navbar = document.getElementById('navbar');

             navbar.classList.toggle('navbar-full-view');
             navbar.classList.toggle('navbar-popup-phone-view');

             const navbarRightPart = document.getElementById('navbar-right-part');
             navbarRightPart.classList.toggle('navbar-popup-phone-view-right-part');
         }
     }
}
</script>

<template>
    <div>
        <div class="navbar-header">
            <button
                aria-label="navigation hamburger"
                aria-controls="navbar"
                aria-expanded="false"
                data-target="#navbar"
                data-toggle="collapse"
                class="navbar-toggle collapsed"
                type="button"
                @click="handleClickNavigation"
            >
                <i class="fa-solid fa-bars"></i>
            </button>
            <a href="/" :class="imageClass">
                <img :src="imageSrc" :alt="projectName" :title="projectName"/>
            </a>
        </div>
        <div class="navbar-full-view navbar-collapse collapse clear" id="navbar">
            <slot />
        </div>
    </div>
</template>

<style>
    @media (max-width: 768px) {
        .navbar-full-view {
            display: none !important;
        }
        .top-navigation .navbar-brand.custom img {
            max-width: 300px !important;
        }
    }

    .navbar-popup-phone-view {
        height: calc(100vh - 50px);
        width: 100vw;
        position: absolute;
        display: flex !important;
        flex-direction: column;
        background-color: var(--color-primary);
        color: var(--text-color);
    }

    .navbar-popup-phone-view-right-part {
        display: flex;
        flex-direction: column;
    }
</style>
